export default __webpack_public_path__ + "static/media/motorcycle.5dec10e6.png";